import type { NClientsList } from '@app/pages/Clients/ClientsList/ClientsList.types';
import {
  ClientsRecordStatuses,
  ClientsRecordStatusesLabel,
  VisitsCategoriesLabel,
  VisitsEmployeesLabel,
  VisitsPeriodLabel,
  VisitsRecordsCount,
  VisitsRecordsCountLabel,
  VisitsRecordsExistenceLabel,
  VisitsServicesLabel,
  VisitsServicesSum,
  VisitsServicesSumLabel,
} from '@app/pages/Clients/ClientsList/components';
import {
  VisitsCategories,
  VisitsClearButton,
  VisitsEmployees,
  VisitsPeriod,
  VisitsRecordsExistenceChild,
  VisitsServices,
  VisitsTags,
  VisitsTagsLabel,
} from '@app/pages/Clients/ClientsList/components/Filters';

export const filtersByVisits: NClientsList.FiltersByGroup = ({
  specificFilterId,
  filterGroupIndex,
}) => {
  const handledFilterGroupIndex = filterGroupIndex || 0;

  return [
    {
      key: 'recordsExistence',
      label: (
        <VisitsRecordsExistenceLabel
          filterGroupIndex={handledFilterGroupIndex}
        />
      ),
      children: [
        {
          key: 'recordsExistenceChild',
          label: (
            <VisitsRecordsExistenceChild
              specificFilterId={specificFilterId || ''}
              filterGroupIndex={handledFilterGroupIndex}
            />
          ),
        },
      ],
    },
    {
      key: 'recordStatuses',
      label: (
        <ClientsRecordStatusesLabel
          filterGroupIndex={handledFilterGroupIndex}
        />
      ),
      children: [
        {
          key: 'recordStatusesChild',
          label: (
            <ClientsRecordStatuses filterGroupIndex={handledFilterGroupIndex} />
          ),
        },
      ],
    },
    {
      key: 'recordsCount',
      label: (
        <VisitsRecordsCountLabel filterGroupIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: 'recordCountChild',
          label: (
            <VisitsRecordsCount filterGroupIndex={handledFilterGroupIndex} />
          ),
        },
      ],
    },
    {
      key: 'visitsTags',
      label: <VisitsTagsLabel filterGroupIndex={handledFilterGroupIndex} />,
      children: [
        {
          key: 'visitsTagsChild',
          label: <VisitsTags filterGroupIndex={handledFilterGroupIndex} />,
        },
      ],
    },
    {
      key: 'period',
      label: <VisitsPeriodLabel filterGroupIndex={handledFilterGroupIndex} />,
      children: [
        {
          key: 'periodChild',
          label: <VisitsPeriod filterGroupIndex={handledFilterGroupIndex} />,
        },
      ],
    },
    {
      key: 'employee',
      label: (
        <VisitsEmployeesLabel filterGroupIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: 'employeeChild',
          label: <VisitsEmployees filterGroupIndex={handledFilterGroupIndex} />,
        },
      ],
    },
    {
      key: 'services',
      label: <VisitsServicesLabel filterGroupIndex={handledFilterGroupIndex} />,
      children: [
        {
          key: 'servicesChild',
          label: <VisitsServices filterGroupIndex={handledFilterGroupIndex} />,
        },
      ],
    },
    {
      key: 'categories',
      label: (
        <VisitsCategoriesLabel filterGroupIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: 'categoriesChild',
          label: (
            <VisitsCategories filterGroupIndex={handledFilterGroupIndex} />
          ),
        },
      ],
    },
    {
      key: 'realizedServicesSum',
      label: (
        <VisitsServicesSumLabel filterGroupIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: 'realizedServicesSumChild',
          label: (
            <VisitsServicesSum filterGroupIndex={handledFilterGroupIndex} />
          ),
        },
      ],
    },
    {
      key: 'visitsClearButton',
      label: <VisitsClearButton filterGroupIndex={handledFilterGroupIndex} />,
    },
  ];
};
